//
// TooltipSortController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "./TooltipSortItem";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortDirection";

var TooltipSortController = createModule("BIRD::TooltipSortController", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        _sort_o: [0,1],
        _sort_n: [0,4],
        removeSortLevel: [0],
        removeSort: [0,1],
        getSortDirection: [4],
        reset: [0],
        canRemoveSortLevel: [2],
        getColumnName: [7],
        isTooltipSortReady: [2],
        getSortItems: [[1]],
        shouldShowResetOption: [2],
        canRemoveSort: [2,1],
    },
    ,
    ["sort"],
]);
export default TooltipSortController;
